import email from '../../Content/Images/email.png';
import phone from '../../Content/Images/phone.png';
import contactJson from "../../Content/Data/ContactUs/contactUs.json";
import AmatyaConsultantsLogo from '../../Content/Images/Logo.png';

function Headbar() {
    return (
        <div className="headbar">
            <div className='nav-brand'>
                <img src={AmatyaConsultantsLogo} alt='AmatyaConsultants'></img>
            </div>
            {/* <span>
                <span>
                    <img src={email} alt="email" className='headbar-img' />
                </span>
                <span>
                    {contactJson.email}
                </span>
            </span>
            <span>
                <span>
                    <img src={phone} alt="email" className='headbar-img' />
                </span>
                <span>
                    {contactJson.contact}
                </span>
            </span> */}
        </div>
    );
}

export default Headbar;
